import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@material-ui/core";
import { useTranslation } from "../../hooks/useTranslation";

/**
 * Dialog para criar ou editar nome/papel de um speaker.
 *
 * Props:
 *   - `open`        boolean
 *   - `mode`        "create" | "edit"
 *   - `initialName` string
 *   - `initialRole` string
 *   - `onClose`     () => void
 *   - `onConfirm`   ({ name, role }) => void
 */
function SpeakerEditDialog({
  open,
  mode = "edit",
  initialName = "",
  initialRole = "",
  onClose,
  onConfirm,
}) {
  const { t } = useTranslation("common");
  const [name, setName] = useState(initialName);
  const [role, setRole] = useState(initialRole);

  useEffect(() => {
    if (open) {
      setName(initialName || "");
      setRole(initialRole || "");
    }
  }, [open, initialName, initialRole]);

  const handleConfirm = () => {
    onConfirm?.({ name: name.trim(), role: role.trim() });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleConfirm();
    }
  };

  const titleKey =
    mode === "create"
      ? "transcription.speakers.dialogs.createTitle"
      : "transcription.speakers.dialogs.editTitle";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      className="transcription-speaker-edit-dialog"
    >
      <DialogTitle>{t(titleKey)}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          variant="outlined"
          margin="dense"
          label={t("transcription.speakers.fieldName")}
          placeholder={t("transcription.speakers.fieldNamePlaceholder")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <TextField
          fullWidth
          variant="outlined"
          margin="dense"
          label={t("transcription.speakers.fieldRole")}
          placeholder={t("transcription.speakers.fieldRolePlaceholder")}
          helperText={t("transcription.speakers.fieldRoleHelper")}
          value={role}
          onChange={(e) => setRole(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("cancel")}</Button>
        <Button color="primary" variant="contained" onClick={handleConfirm}>
          {mode === "create"
            ? t("transcription.speakers.dialogs.createConfirm")
            : t("transcription.speakers.dialogs.editConfirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SpeakerEditDialog;
